/**
 * @param {toUrl} 需要跳转的url
 * @param {name} 跳转项目的名称，防止打开两个页面
 * @param {interval} 发送消息的间隔 默认 500
 * @param {payload} //参数
 */
export function toExternalPortal(
  toUrl: string,
  interval = 500,
  payload?: any
) {
  // http://localhost:8080/#/?from=F2E 商车Url
  if (
    location.href.indexOf("fat") >= 0 ||
    location.href.indexOf("carrierglobe") >= 0
  ) {
    let timerContainer: any = null;
    const token = localStorage.getItem("iam-token");
    const vehWindow = window.open(toUrl, toUrl);
    let tepValues = { token: token,loginToken: localStorage.getItem('login-token') || ""};
    if (payload) {
      tepValues = { ...tepValues, ...payload };
    }
    const messageValue = JSON.stringify(tepValues);
    let messageIndex = 0; //发送消息次数
    const handlePostMessage = () => {
      if (messageIndex < 3) {
        if (vehWindow) {
          vehWindow.postMessage(messageValue, toUrl);
        }
        messageIndex += 0.5;
      } else {
        clearInterval(timerContainer);
        timerContainer = null;
      }
    };
    timerContainer = setInterval(handlePostMessage, interval);
    return;
  }
}

export function clearStorage() {
  let userDisplayName = "用户名";
  try {
    userDisplayName = JSON.parse(
      localStorage.getItem("webphone") || "{}"
    ).userDisplayName;
  } catch (e) {
    console.log(
      "webphone userDisplayName is not a valid JSON, clearing localStorage"
    );
  }

  // 每次重新登陆，保存勾选的我的待办
  const excludedText = [`_${userDisplayName}`];

  const excludedKeys = [
    "language",
    "commonWords",
    "index_nav_hide_switch",
    "[@yzsf2e/render-core]COLUMN_SCHEME",
  ];

  // 遍历 localStorage 的所有 key
  Object.keys(localStorage).forEach((key) => {
    if (
      !excludedKeys.includes(key) &&
      !excludedText.some((item) => key.includes(item))
    ) {
      localStorage.removeItem(key);
    }
  });
}
export const setIamToken = (token: string) => {
  return localStorage.setItemetItem("iam-token", token);
};

export const getIamToken = () => {
  return localStorage.getItem("iam-token");
};

export const removeToken =()=>{
  return localStorage.removeItem("iam-token");
}